import React, { useState, memo, useEffect } from 'react';
import './App.css';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { getUserData } from './store/reducers/getUserSlice';
import { Route, Routes, useLocation } from 'react-router-dom';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { RootState } from './store/store';
import DebtorDocumentForm from './shared/forms/DebtorDocumentForm';
import ErrorPage from './components/ErrorPage';
import srv from './services';
import { serviceToken } from './store/reducers/serviceTokenSlice';
import PaymentPage from './shared/pages/PaymentPage';
import SuccesssPage from './shared/pages/SuccesssPage';
import FaultPage from './shared/pages/FaultPage';

const useStyles = makeStyles()(() => ({
  container: {
    height: '100%',
    width: '100%',
    overflow: 'auto',
  },

  nameBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'center',
    textAlign: 'right',
    fontSize: '10px',
    overflow: 'auto',
  },

  box: {
    width: '40%',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    overflow: 'auto',
    padding: '10px',
    textAlign: 'left',
    fontSize: '12px',
  },

  label: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    padding: '15px',
    textAlign: 'left',
    fontSize: '12px',
    overflow: 'hidden',
  },

  buttonLogout: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    textAlign: 'end',
    '& .MuiButton-root': {
      height: '50px',
      width: '150px',
      borderRadius: '10px',
      fontSize: '10px',
      borderColor: '#141361',
      color: '#141361',
      fontWeight: 600,
    },
  },
}));

const App = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const region = params.get('region');
  const token = params.get('token');

  const [value, setValue] = React.useState(0);
  const [currentUser] = useState(
    sessionStorage.getItem('current_user')
      ? JSON.parse(sessionStorage.getItem('current_user') as any).profile
      : null
  );

  const user = useSelector((state: RootState) => state.getUser, shallowEqual);

  //  const tokenDataVerifier = useSelector(
  //   (state: RootState) => state.tokenDataVerifier,
  //   shallowEqual
  //  );

  const dispatchUserData = (data: any) => {
    if (Object.keys(data) && Object.keys(data).length > 0) {
      dispatch(getUserData(data));
    }
  };

  // const isPaymentPage = location.pathname === '/paymentPage';
  const isSpecialPage = ['/paymentPage', '/successsPage', '/faultPage'].includes(location.pathname);

  return (
    // <React.Fragment>
    <div className={classes.container}>
      <Box style={{ height: '100%' }}>
        <div style={{ height: '100%' }}>
          <Routes>
            {/* <Route path="login-callback" element={<LoginCallback />} /> */}
            <Route path="/paymentPage" element={<PaymentPage />} />
            <Route path="/successsPage" element={<SuccesssPage />} />
            <Route path="/faultPage" element={<FaultPage />} />
          </Routes>

          {!isSpecialPage && (!token || !region ? <ErrorPage /> : <DebtorDocumentForm />)}
        </div>
      </Box>
    </div>
    // </React.Fragment>
  );
};

export default memo(App);
